const en = {
    errorSubtitleNull: "Do you think that I'm frightening? Organ chords and lightning",
    skippingCosmoChecksOnLocal: "Skipping Cosmo pings due to CORS errors. See https://plusreed.atlassian.net/wiki/spaces/PLUSREEDCO/pages/548700161/CosmoService+in+Development for more info.",
    cosmoCheckingStatus: "getCosmoStatus",
    cosmoGetPrcomPageCfg: "getPrComPageConfig",
    cosmoGetPrcomFlags: "getPrComFlags",
    waitingOnLastFm: "Pinging Last.fm...",
    loadingAnnouncement: "Loading announcement data",
    announcementDisabled: "Announcement disabled via local config",
    toyboxDisabled: "Toybox disabled via local config",

}

export default en
